import { render, staticRenderFns } from "./draft-rows-table.vue?vue&type=template&id=49ee14ea"
import script from "./draft-rows-table.vue?vue&type=script&lang=js"
export * from "./draft-rows-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports